// extracted by mini-css-extract-plugin
export var aspectRatio = "imageContainer-module--aspectRatio--ea37f";
export var imageContainer = "imageContainer-module--imageContainer--032c6";
export var portalBox = "imageContainer-module--portalBox--56c67";